import React from 'react';

import * as S from '../styled';
import ItemIcon from '../ItemIcon';

interface Props {
  to: string,
  name: string
  icon?: string,
  level: number,
  badge: string
  isOpen: boolean
  isFolder: boolean
  hasChild: boolean
  setOpen: { (isOpen: boolean): void }
}

const SidebarItem = ({
  to,
  icon,
  name,
  level,
  badge,
  isOpen,
  isFolder,
  hasChild,
  setOpen,
}: Props) => (
  <S.StyledLink
    to={to}
    iscat={level === 0 ? 0 : 1}
    isopen={isOpen ? 1 : 0}
    style={{
      paddingLeft: level > 1 ? (level * 28) - 14 : 14,
    }}
  >
    <ItemIcon
      icon={icon}
      level={level}
      isFolder={isFolder}
    />
    <S.Name>{name}</S.Name>
    {badge && <S.Badge>{badge}</S.Badge>}

    {hasChild && (
      <S.Arrow
        isOpen={isOpen}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(!isOpen);
        }}
      />
    )}
  </S.StyledLink>
);

SidebarItem.defaultProps = {
  icon: null,
};

export default SidebarItem;
